import { useState, useEffect } from "react";
import { apiPostFile, apiGet } from "../api/api";

export default function InventarioForm() {

  // -----------------------------------------
  // CAMPOS GERAIS
  // -----------------------------------------
  const [tipoLocalizacao, setTipoLocalizacao] = useState("");
  const [tiposLocalizacao, setTiposLocalizacao] = useState([]);

  const [tipo, setTipo] = useState("");
  const [tipos, setTipos] = useState([]);

  const [obs, setObs] = useState("");

  const [lat, setLat] = useState("");
  const [lon, setLon] = useState("");

  const [operador, setOperador] = useState("");
  const [tipologia, setTipologia] = useState("");
  const [detalhe, setDetalhe] = useState("");

  // LOCALIZAÇÃO ADMINISTRATIVA (autocomplete)
  const [localizacoes, setLocalizacoes] = useState([]);
  const [localizacao, setLocalizacao] = useState("");
  const [filtroLoc, setFiltroLoc] = useState("");

  // FOTOS
  const [files, setFiles] = useState([]);
  const [preview, setPreview] = useState([]);
  const [loading, setLoading] = useState(false);

  const [operadores, setOperadores] = useState([]);
  const [tipologias, setTipologias] = useState([]);

  // -----------------------------------------
  // LOAD OPERADORES
  // -----------------------------------------
  useEffect(() => {
    async function loadOperadores() {
      const data = await apiGet("/operadores/");
      setOperadores(data);
    }
    loadOperadores();
  }, []);

  // -----------------------------------------
  // LOAD TIPOS (Estático / Móvel)
  // -----------------------------------------
  useEffect(() => {
    async function loadTipos() {
      const data = await apiGet("/tipos/");
      setTipos(data.sort((a, b) => a.nome.localeCompare(b.nome)));
    }
    loadTipos();
  }, []);

  // -----------------------------------------
  // LOAD TIPOS LOCALIZAÇÃO (STREET / INDOOR)
  // -----------------------------------------
  useEffect(() => {
    async function loadTiposLocalizacao() {
      const data = await apiGet("/tipos-localizacao/");
      setTiposLocalizacao(data.sort((a, b) => a.nome.localeCompare(b.nome)));
    }
    loadTiposLocalizacao();
  }, []);

  // -----------------------------------------
  // LOAD TIPOLOGIAS
  // -----------------------------------------
  useEffect(() => {
    async function loadTipologias() {
      const data = await apiGet("/tipologias/");
      setTipologias(data);
    }
    loadTipologias();
  }, []);

  // -----------------------------------------
  // LOAD LOCALIZAÇÕES (autocomplete)
  // -----------------------------------------
  useEffect(() => {
    async function loadLocalizacoes() {
      try {
        const data = await apiGet("/localizacoes/opcoes");
        setLocalizacoes(data);
      } catch (e) {
        console.error("Erro ao carregar localizações", e);
      }
    }
    loadLocalizacoes();
  }, []);

  // -----------------------------------------
  // GPS AUTOMÁTICO
  // -----------------------------------------
  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setLat(pos.coords.latitude.toFixed(6));
          setLon(pos.coords.longitude.toFixed(6));
        },
        () => {
          alert("⚠ Não foi possível obter a localização automática.");
        }
      );
    }
  }, []);

  // -----------------------------------------
  // PREVIEW FOTOS
  // -----------------------------------------
  function handleFileChange(e) {
    const selected = Array.from(e.target.files);
    setFiles(selected);
    setPreview(selected.map((f) => URL.createObjectURL(f)));
  }

  // -----------------------------------------
  // SUBMIT
  // -----------------------------------------
  async function submit(e) {
    e.preventDefault();
    setLoading(true);

    const fd = new FormData();

    let distrito = "";
    let concelho = "";
    let freguesia = "";

    if (localizacao) {
      const partes = localizacao.split(" - ").map((p) => p.trim());
      if (partes.length === 3) {
        [distrito, concelho, freguesia] = partes;
      }
    }

    fd.append("tipo_localizacao", tipoLocalizacao);
    fd.append("tipo", tipo);
    fd.append("obs", obs);
    fd.append("latitude", lat);
    fd.append("longitude", lon);

    fd.append("operador_id", operador);
    fd.append("tipologia", tipologia);
    fd.append("detalhe", detalhe);

    fd.append("distrito", distrito);
    fd.append("concelho", concelho);
    fd.append("freguesia", freguesia);

    for (let f of files) fd.append("files", f);

    try {
      await apiPostFile("/inventario/", fd);
      alert("Inventário registado!");

      // reset
      setTipoLocalizacao("");
      setTipo("");
      setObs("");
      setOperador("");
      setTipologia("");
      setDetalhe("");
      setLocalizacao("");
      setFiltroLoc("");
      setFiles([]);
      setPreview([]);
    } catch {
      alert("Erro ao enviar inventário.");
    }

    setLoading(false);
  }

  return (
    <div style={{ padding: 20 }}>
      <h1>Novo Inventário</h1>

      <form onSubmit={submit}>
        
        <h3>Dados gerais</h3>

        {/* TIPO LOCALIZAÇÃO */}
        <select value={tipoLocalizacao} onChange={(e) => setTipoLocalizacao(e.target.value)}>
          <option value="">-- Tipo de Localização --</option>
          {tiposLocalizacao.map(t => (
            <option key={t.id} value={t.nome}>{t.nome}</option>
          ))}
        </select>

        {/* TIPO */}
        <select value={tipo} onChange={(e) => setTipo(e.target.value)}>
          <option value="">-- Tipo --</option>
          {tipos.map(t => (
            <option key={t.id} value={t.nome}>{t.nome}</option>
          ))}
        </select>

        <textarea placeholder="Observações" value={obs} onChange={(e) => setObs(e.target.value)} />

        <h3>Informação do Suporte</h3>

        {/* Operadores */}
        <select value={operador} onChange={(e) => setOperador(e.target.value)}>
          <option value="">-- Operador --</option>
          {operadores.map(op => (
            <option key={op.id} value={op.id}>{op.nome}</option>
          ))}
        </select>

        {/* Tipologias */}
        <select value={tipologia} onChange={(e) => setTipologia(e.target.value)}>
          <option value="">-- Tipologia --</option>
          {tipologias.map(tp => (
            <option key={tp.id} value={tp.nome}>{tp.nome}</option>
          ))}
        </select>

        <input placeholder="Detalhe" value={detalhe} onChange={(e) => setDetalhe(e.target.value)} />

        <h3>Localização administrativa</h3>

        {/* AUTOCOMPLETE */}
        <div style={{ position: "relative", maxWidth: 400 }}>
          <input
            type="text"
            placeholder="Pesquisar localização..."
            value={localizacao}
            onChange={(e) => {
              setLocalizacao(e.target.value);
              setFiltroLoc(e.target.value.toLowerCase());
            }}
            style={{ width: "100%", padding: 8 }}
          />

          {filtroLoc.length > 0 && (
            <div
              style={{
                position: "absolute",
                top: "40px",
                width: "100%",
                background: "white",
                border: "1px solid #ccc",
                maxHeight: 200,
                overflowY: "auto",
                zIndex: 999,
              }}
            >
              {localizacoes
                .filter((loc) => loc.toLowerCase().includes(filtroLoc))
                .slice(0, 40)
                .map((loc, i) => (
                  <div
                    key={i}
                    onClick={() => {
                      setLocalizacao(loc);
                      setFiltroLoc("");
                    }}
                    style={{
                      padding: 8,
                      cursor: "pointer",
                      borderBottom: "1px solid #eee"
                    }}
                  >
                    {loc}
                  </div>
                ))}
            </div>
          )}
        </div>

        <h3>Localização GPS</h3>
        <input placeholder="Latitude" value={lat} onChange={(e) => setLat(e.target.value)} />
        <input placeholder="Longitude" value={lon} onChange={(e) => setLon(e.target.value)} />

        <h3>Fotos</h3>
        <input type="file" multiple onChange={handleFileChange} />

        <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
          {preview.map((src, idx) => (
            <img key={idx} src={src} width="120" style={{ borderRadius: 8 }} />
          ))}
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "A guardar..." : "Guardar"}
        </button>

      </form>
    </div>
  );
}
